var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('toasts-basic'),_c('toasts-translucent'),_c('toasts-variants'),_c('toasts-delay'),_c('toasts-target'),_c('toasts-links'),_c('toasts-advance')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }